import { Routes } from '@angular/router';
import {ResultsComponent} from './features/results/results.component';
import {CompareComponent} from './features/compare/compare.component';
import {LookupComponent} from './features/lookup/lookup.component';
import {initGuard} from './shared/guards/init.guard';
import {SettingsComponent} from './features/settings/settings.component';
import {SelectionComponent} from './features/selection/selection.component';

// routes
export const routes: Routes = [
  {
    path: 'select/:token',
    component: SelectionComponent,
  },
  {
    path: ':session_id',
    canActivate: [initGuard],
    children: [
      {
        path: '',
        component: LookupComponent
      },
      {
        path: 'results',
        component: ResultsComponent
      },
      {
        path: 'compare',
        component: CompareComponent
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes')
      },
      {
        path: 'selection',
        component: SelectionComponent
      },
      {
        path: '**',
        redirectTo: ''
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
